module.exports = __webpack_public_path__ + "de77a722/img/verified-icon.f93bbc14.svg";